import React, { useEffect, useState } from 'react';
import { RecommendedProduct, Typography, Link, Button, ProductCarousel } from '@hpstellar/core/visId';
import { useProductProps } from '../../hooks/useProductProps';
import { ProductTileSkeleton } from '@hpstellar/core';
import useProductPrice from '../../hooks/useProductPrice';
import useSiteConfig from '../../hooks/useSiteConfig';

import ETRWCSApi from '../../core/src/etr-wcs-api-client';

import './product-list.less';

const ViewMoreButton = ({ path, children = 'View more' }) => {
    const { basename } = useSiteConfig();
    return (
        <Button theme="dark" to={`${basename}/${path}`}>
            {children}
        </Button>
    );
};

export default ({ path, size = 4, title, description, startOver, queryFilter }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showViewMore, setShowViewMore] = useState(false);
    const [products, setProducts] = useState([]);
    const { prices } = useProductPrice(isLoading ? [] : products);
    const [getProductProps] = useProductProps();
    useEffect(() => {
        setIsLoading(true);
        ETRWCSApi.component.get('vwa', 'finder-results', { path, pageSize: size }).then(({ vwaDetails }) => {
            const { products, totalProducts } = vwaDetails || {};
            //TODO: Need to ask about an error state in cause we get no products or API failes
            setProducts(products || []);
            if (totalProducts > size) {
                setShowViewMore(true);
            }
            setIsLoading(false);
        });
    }, [path, size]);

    return (
        <div className="result-container">
            <Typography className="result-title" tag="h2" variant="l">
                {title}
            </Typography>
            <Typography tag="h3" className="result-description" variant="h4">
                {description}
            </Typography>
            <ProductCarousel
                className="prod-carousel"
                title={description}
                equalHeight
                infinite
                CarouselIndicatorProps={{ className: 'result-carousel-controls' }}
            >
                {isLoading
                    ? [0, 1, 3, 4].map(index => <ProductTileSkeleton key={index} className="tile-loader" />)
                    : products.map(product => {
                          const price = prices[product.sku];
                          const productProps = getProductProps(product, price);

                          const translatedProps = {
                              title: productProps?.product?.name,
                              image: {
                                  ...productProps?.product?.images?.[0],
                                  variant: 'wide',
                              },
                              PriceProps: {
                                  oldPrice: Helpers.formatCurrency(productProps?.priceProps?.regularPrice, '$', true),
                                  finalPrice: Helpers.formatCurrency(productProps?.priceProps?.salePrice, '$', true),
                              },
                              LinkProps: {
                                  children: 'View details',
                                  target: '_blank',
                                  to: productProps?.productLinkProps?.to,
                              },
                              purchaseBtnProps: {
                                  ...(productProps?.purchaseBtnProps || {}),
                                  endIcon: null,
                                  className: 'actionBtns',
                              },
                              translations: {
                                  openDescriptionBtnText: 'More details',
                                  descriptionLinkText: 'See more',
                                  moreDescriptionLinkText: 'See more',
                              },
                          };
                          return (
                              <RecommendedProduct
                                  className="questioneer-product-tile"
                                  key={product.sku}
                                  {...translatedProps}
                              />
                          );
                      })}
            </ProductCarousel>
            <div className="navigation-buttons centered">
                <Link className="startOverButton" onClick={startOver}>
                    Start Over
                </Link>
                {showViewMore && <ViewMoreButton path={queryFilter.path} />}
            </div>
        </div>
    );
};
